export enum PerformedByEnum {
  Clinician = 1,
  Patient = 2,
  Caregiver = 3
}

export const PerformedByOptions = [
{ id: 1, label: 'Clinician' },
{ id: 2, label: 'Patient' },
{ id: 3, label: 'Caregiver' }
];
